import { analytics } from "@/lib/analytics/ga4";
import { getAuth } from "firebase/auth";

export async function signOut() {
  const auth = getAuth();
  await auth.signOut();

  analytics.event({
    action: "logout",
    category: "auth",
    custom_parameters: {
      user_id: auth.currentUser?.uid,
    },
  });
}
